import { normalizeSearchText, searchIncludes } from "../text-search.ts";

export function patientNameParts(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) {
    return { first: parts[0] ?? "", last: "" };
  }
  const last = parts[parts.length - 1] ?? "";
  const first = parts.slice(0, -1).join(" ");
  return { first, last };
}

/** Affichage : NOM Prénom */
export function formatPatientDisplayName(name: string): string {
  const { first, last } = patientNameParts(name);
  if (!last) return first;
  return `${last.toUpperCase()} ${first}`;
}

export function patientMatchesSearch(name: string, query: string): boolean {
  const q = query.trim();
  if (!q) return true;
  const { first, last } = patientNameParts(name);
  if (searchIncludes(name, q) || searchIncludes(formatPatientDisplayName(name), q)) {
    return true;
  }
  if (last && searchIncludes(last, q)) return true;
  if (first && searchIncludes(first, q)) return true;
  return false;
}

/** Plus petit = meilleur match (nom de famille prioritaire). */
export function patientSearchRank(name: string, query: string): number {
  const q = query.trim();
  if (!q) return 0;
  const { first, last } = patientNameParts(name);
  const nq = normalizeSearchText(q);
  const nl = normalizeSearchText(last);
  const nf = normalizeSearchText(first);
  if (last && nl.startsWith(nq)) return 0;
  if (last && nl.includes(nq)) return 1;
  if (first && nf.startsWith(nq)) return 2;
  if (first && nf.includes(nq)) return 3;
  if (searchIncludes(name, q)) return 4;
  return 99;
}

export function comparePatientsBySearch(
  a: string,
  b: string,
  query: string,
): number {
  const rank = patientSearchRank(a, query) - patientSearchRank(b, query);
  if (rank !== 0) return rank;
  return formatPatientDisplayName(a).localeCompare(
    formatPatientDisplayName(b),
    "fr",
  );
}
